import { Backdrop, Box, CircularProgress } from '@mui/material';

interface Props {
  open: boolean;
  fullScreen?: boolean;
}

const Loader = ({ open, fullScreen }: Props) => {
  if (!open) {
    return null;
  }

  if (fullScreen) {
    return (
      <Backdrop
        sx={{
          zIndex: 2000,
        }}
        open
      >
        <CircularProgress />
      </Backdrop>
    );
  }

  return (
    <Box
      component="span"
      sx={{
        display: 'block',
        m: '0 auto',
        p: 4,
        textAlign: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Loader;
